import { render, staticRenderFns } from "./lookCOeder.vue?vue&type=template&id=6505642e&scoped=true"
import script from "./lookCOeder.vue?vue&type=script&lang=ts"
export * from "./lookCOeder.vue?vue&type=script&lang=ts"
import style0 from "./lookCOeder.vue?vue&type=style&index=0&id=6505642e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505642e",
  null
  
)

export default component.exports